module.exports = __webpack_public_path__ + "static/media/image1.ec0aa361.jpg";